import Box from "@mui/material/Grid";
import IconButtonAddContent from "../Buttons/IconButtonAddContent";
import { formatMediaUrl } from "../../services/adsCampaigns";
import { useDispatchApp } from "../../lib/redux";
import { getPathDatabaseByRole } from "../../actions/auth";
import CardMedia from "../Media/CardMedia";
import ContainerOverlay from "../Containers/ContainerOverlay";
import IconButton from "../Buttons/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Typography from "@mui/material/Typography";
import { getUniqueID } from "../../utils/numbers";
import { Masonry } from "@mui/lab";
import TooltipOptimization from "../Tooltip/TooltipOptimization";

const MultiContentField = ({
  platform,
  id = getUniqueID(),
  fieldPath = "",
  label = "",
  acceptedFormats,
  mediaUrls = [],
  propsPostsAdsPlatforms = {},
  showGalleryAdsPlatformsOption = true,
  showGalleryGoogleOption = false,
  onChange = () => {},
  onDelete = () => {},
  disabled = false,
  language,
  showTooltip = false,
  titleTooltip = "",
  actionTooltip = "",
  initialValuesAddContent = {},
}) => {
  const dispatch = useDispatchApp();
  const { userID } = dispatch(getPathDatabaseByRole());

  const domFieldPath = fieldPath || id;

  return (
    <Box id={domFieldPath || undefined} data-field={domFieldPath || undefined}>
      <Typography variant="body1">{label}</Typography>
      <Masonry columns={{ xs: 2, sm: 3 }} spacing={2} sx={{ mt: 1 }}>
        {!disabled && (
          <TooltipOptimization
            isOpen={showTooltip}
            titleTooltip={titleTooltip}
            actionTooltip={actionTooltip}
          >
            <Box>
              <IconButtonAddContent
                id={id}
                acceptedFormats={acceptedFormats}
                showGenerateWithAIOption={false}
                showGalleryGoogleOption={showGalleryGoogleOption}
                showGalleryAdsPlatformsOption={showGalleryAdsPlatformsOption}
                propsPostsAdsPlatforms={propsPostsAdsPlatforms}
                onAddContent={(urls) => {
                  const contents = urls.map((url) => formatMediaUrl(url));
                  onChange(contents);
                }}
                onCallbackSaveCanva={(mediaUrl) => {
                  const canvaContent = formatMediaUrl({
                    url: mediaUrl,
                    type: "upload",
                  });
                  onChange([canvaContent]);
                }}
                initialValues={{
                  language,
                  platform,
                  ...initialValuesAddContent,
                }}
                multiple={true}
                pathStorage={`adsCampaigns/${userID}/`}
                mode="icon"
                sx={{
                  width: 100,
                  height: 100,
                }}
              />
            </Box>
          </TooltipOptimization>
        )}
        {mediaUrls.map((url, index) => {
          return (
            <Box
              key={index}
              sx={{
                position: "relative",
                "&:hover .overlay": {
                  opacity: 1,
                },
              }}
            >
              <CardMedia
                url={url}
                sx={{
                  objectFit: "cover",
                  borderRadius: 3,
                  height: "auto",
                  width: "100%",
                }}
                propsType={{
                  controls: false,
                  autoplay: false,
                }}
              />
              <ContainerOverlay
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  top: 0,
                  right: 0,
                }}
              >
                {!disabled && (
                  <IconButton
                    edge="start"
                    disabled={disabled}
                    sx={{ p: 0 }}
                    onClick={() => {
                      if (disabled) return;
                      onDelete(index);
                    }}
                  >
                    <DeleteIcon
                      sx={{
                        color: "white !important",
                      }}
                    />
                  </IconButton>
                )}
              </ContainerOverlay>
            </Box>
          );
        })}
      </Masonry>
    </Box>
  );
};

export default MultiContentField;
